import React from 'react';
import { Navbar } from '../common/Navbar';
import { Footer } from '../common/Footer';

const Layout = ({ children, user, isAuthenticated, onLogout }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--color-background)] w-full overflow-x-hidden">
       <Navbar user={user} isAuthenticated={isAuthenticated} onLogout={onLogout} />
      <main className="flex-grow w-full">
        {children}
      </main>
       <Footer />
    </div>
  );
};

export default Layout;
